export default {
    url: import.meta.env.VITE_API_URL,
    menuDomain: import.meta.env.VITE_MENU_DOMAIN,

    /** Mirrors the backend's OTP_LENGTH — the verify screen renders exactly this many boxes. */
    otpLength: 4,

    /** Mirrors the backend's OTP_TTL_MINUTES — how long before a code can be re-sent. */
    otpTtlMinutes: 5,

    /** Mirrors the backend's ADMIN_PERMISSION_MODELS. `admins` is absent — it is gated on isSuper. */
    permissionModels: ["stores", "clients", "coupons", "subscriptions", "support", "logs"],
};
